import { render, staticRenderFns } from "./RefreshNotice.vue?vue&type=template&id=01bf4ccc&scoped=true&"
import script from "./RefreshNotice.vue?vue&type=script&lang=js&"
export * from "./RefreshNotice.vue?vue&type=script&lang=js&"
import style0 from "./RefreshNotice.vue?vue&type=style&index=0&id=01bf4ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf4ccc",
  null
  
)

export default component.exports